<template>
  <div class="flex flex-col gap-4">
    <!-- Main content -->
    <div class="text-brown-800 font-inter">
      <div class="text-text-display-lg font-black tracking-[-0.03em]">We're glad you are here!</div>
      <div class="text-text-body-md font-semibold mt-[10px]">
        To help personalise your experience, tell us a little more ☺️
      </div>
    </div>

    <!-- Button options -->
    <div class="flex flex-col gap-4 w-full mt-4">
      <DsRadioCard
        v-for="item in memberStatusOptions"
        :key="item"
        :model-value="selectedMemberStatus"
        :value="item"
        :label="item"
        name="memberStatus"
        align="center"
        hide-indicator
        @update:modelValue="onSelectLifeStage"
      />
    </div>
  </div>
</template>

<script>
import { RadioCard as DsRadioCard } from '@team-hogc/hogc-one-design-system';

export default {
  name: 'RegisterMemberStatus',
  props: ['registrationPageData'],
  components: {
    DsRadioCard,
  },
  data() {
    return {
      selectedMemberStatus: '',
      memberStatusOptions: ['I attend HOGC', 'I want to know more about HOGC'],
    };
  },
  methods: {
    onSelectLifeStage(memberStatus) {
      this.selectedMemberStatus = memberStatus;
      this.$store.dispatch('registration/updateMemberStatus', memberStatus);
      this.$emit('next');
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.registrationPageData.selectedMemberStatus) {
        this.selectedMemberStatus = this.registrationPageData.selectedMemberStatus;
      }
    });
  },
};
</script>
